import { render, staticRenderFns } from "./PartnerModificationIframe.vue?vue&type=template&id=07ca1fd2&"
import script from "./PartnerModificationIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerModificationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports